import { render, staticRenderFns } from "./ReportTableCard.vue?vue&type=template&id=72a6d860&"
import script from "./ReportTableCard.vue?vue&type=script&lang=js&"
export * from "./ReportTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports